export default {
      id: "i-arrow-right-white-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "img/sprite.svg#i-arrow-right-white",
      toString: function () {
        return this.url;
      }
    }